// extracted by mini-css-extract-plugin
module.exports =  {"content":"s81R5_oUCvbAnvY9faw5","details":"wGr7ZoaUCVFQ_wOdi4mc","detail":"UH1dOzqm6MeBj8vGo54_","label":"KDs6cO2wE9lQnDRXpi_m","buttonWrapper":"I9bg2IpBlMdLbw2vccyY"};